import React from 'react'
import { FormattedMessage } from 'react-intl'
import Tooltip from 'components/Tooltip'

import InfoIcon from 'assets/icons/info-icon16px'

import { Label, TextAreaError } from './style'

const tooltipXOffset = 0
const tooltipYOffset = 16
const UploadSiteFiles = ({
  field,
  label,
  error,
  dataTest,
  infoTooltip,
  zIndex,
  marginTopError='16px',
  hyper,
  textForLink,
  disabled = false,
  isOptional = false
}) => {
  return (
    <div data-testid='test-textarea' style={{ height: '10%'}}>
      {label && (
        <div style={{ marginBottom: '16px' }}>
          {React.isValidElement(label)
            ? label
            : label && (
              <Label data-test={`label-${dataTest}`} htmlFor={`input-${field}`}>
                <section style={{ display: 'flex', alignItems: 'center' }}>
                  <FormattedMessage id={label} />
                  {infoTooltip && !disabled &&(
                    <Tooltip
                      style={{ zIndex: 1000 }}
                      zIndex={zIndex}
                      placement="bottom"
                      trigger={['hover']}
                      align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                      overlay={{ label: label, infoTooltip: infoTooltip }}
                      hyper={hyper}
                      textForLink={textForLink}
            
                    >
                      <div>
                        <InfoIcon />
                      </div>
                    </Tooltip>
                  )}
                </section>
                <span>{isOptional && <FormattedMessage id="optional" />}</span>
              </Label>
            )}
        </div>
      )}
      {error && error.field === field && (
        <TextAreaError marginTopError={marginTopError} data-test="validation-error-message">
          <FormattedMessage id={error.error} />
        </TextAreaError>
      )}
    </div>
  )
}

export default UploadSiteFiles
